import React from "react";
import DashboardLayout from "../DashboardLayout";
import { Link } from "react-router-dom";

const AllReports = () => {
  const reportSections = [
    {
      title: "Ad Performance",
      links: [
        {
          to: "/ad-view-count",
          label: "Ad View Count",
          desc: "Total ad views per game, user type (guest/registered), and time period (daily, weekly, monthly)",
        },
        // {
        //   to: "/ad-revenue-per-view",
        //   label: "Ad Revenue per View (RPM/RPC)",
        //   desc: "Revenue generated per 1,000 impressions (RPM) or per click (RPC)",
        // },
        // {
        //   to: "/click-through-rate",
        //   label: "Click-Through Rate (CTR)",
        //   desc: "Percentage of users who click on ads after viewing",
        // },
        {
          to: "/fill-rate",
          label: "Fill Rate",
          desc: "Percentage of ad requests successfully filled by ad networks",
        },
      ],
    },
    {
      title: "Game-Level",
      links: [
        {
          to: "/top-games-by-ad-views",
          label: "Top Games by Ad Views",
          desc: "Which games generate the most ad impressions?",
        },
        // {
        //   to: "/ad-revenue-per-game",
        //   label: "Ad Revenue per Game",
        //   desc: "Breakdown of earnings by game",
        // },
        {
          to: "/ad-placement-performance",
          label: "Ad Placement Performance",
          desc: "Compare revenue from different ad placements (pre-roll, mid-game, post-game, rewarded ads)",
        },
      ],
    },
    {
      title: "Time-Based",
      links: [
        {
          to: "/peak-ad-view-times",
          label: "Peak Ad View Times",
          desc: "Identify when users watch the most ads (hourly/daily trends)",
        },
        {
          to: "/seasonal-trends",
          label: "Seasonal Trends",
          desc: "Compare ad performance during holidays or special events",
        },
      ],
    },
    {
      title: "Geographic & Demographic",
      links: [
        {
          to: "/ad-revenue-by-country-region",
          label: "Ad Revenue by Region",
          desc: "Revenue breakdown by country/region to spot high-CPM areas",
        },
        {
          to: "/user-demographics",
          label: "Device/Platform",
          desc: "Device type affecting ad engagement",
        },
      ],
    },
    {
      title: "User Feedback & Ad Experience",
      links: [
        {
          to: "/ad-skipping-cancellation-rate",
          label: "Ad Skipping Rate",
          desc: "How often users skip or cancel ads",
        },
        {
          to: "/user-complaints-surveys",
          label: "User Surveys",
          desc: "Qualitative feedback on ad experience",
        },
      ],
    },
    {
      title: "A/B Testing",
      links: [
        {
          to: "/ad-format-comparison",
          label: "Format Comparison",
          desc: "Rewarded vs. interstitial vs. banner ad performance",
        },
        {
          to: "/user-frequency-capping-impact",
          label: "Frequency Capping Impact",
          desc: "Does limiting ads per session improve retention?",
        },
      ],
    },
    {
      title: "User Engagement",
      links: [
        {
          to: "/ad-views-per-user",
          label: "Ad Views per User",
          desc: "Average number of ads watched per user (guest vs. registered)",
        },
        {
          to: "/session-length-vs-ad-views",
          label: "Session Length vs. Ad Views",
          desc: "Correlation between how long users play and how many ads they watch",
        },
        {
          to: "/retention-ad-frequency",
          label: "Retention & Ad Frequency",
          desc: "Do users who watch more ads return more often?",
        },
        {
          to: "/top-users-by-ad-views",
          label: "Top Users by Ad Views",
          desc: "Identify high-value users who engage with ads frequently",
        },
      ],
    },
    {
      title: "Fraud & Invalid Traffic",
      links: [
        {
          to: "/suspicious-activity-alerts",
          label: "Suspicious Activity Alerts",
          desc: "Detect unusual patterns (e.g., bot views)",
        },
        {
          to: "/Ad-blocking-detection",
          label: "Ad Blocking Detection",
          desc: "Track users blocking ads to refine monetization",
        },
      ],
    },
    
    {
      title: "Ad Network Performance & Stats",
      links: [
        {
          to: "/revenue-by-ad-network",
          label: "Ads by Network",
          desc: "Compare number of ads from different ads-providers",
        },
        //////////////////////////////this one is to fetching Ads Network stats
        // {
        //   to: "/ad-network-stats",
        //   label: "Ads Network Stats",
        //   desc: "Stats data of different ads-providers",
        // },
        ////////////////////////////////////////////////////////////
        // {
        //   to: "/fallback-performance",
        //   label: "Fallback Performance",
        //   desc: "Waterfall mediation fill rates & eCPM rankings",
        // },
      ],
    },
  ];

  return (
    <DashboardLayout>
      <div className="row g-3 p-3">
        {reportSections.map((section, idx) => (
          <div className="col-sm-12 col-md-6 col-lg-4" key={idx}>
            <div className="card bg-dark text-white h-100">
              <div className="card-body d-flex flex-column">
                <h5 className="card-title mb-3">{section.title}</h5>
                <ul className="list-group list-group-flush flex-grow-1">
                  {section.links.map((item, i) => (
                    <li
                      key={i}
                      className="list-group-item bg-secondary bg-opacity-10 text-white rounded mb-2 border-0 px-3 py-2"
                    >
                      <Link
                        to={item.to}
                        className="text-white text-decoration-none"
                      >
                        <b>{item.label}:</b> {item.desc}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
};

export default AllReports;
